(function (){
    'use strict';

    angular
        .module('emails', [
            'ui.router',
            'ui.bootstrap',
            'ngDialog',
            'ui.select',
            'ngSanitize',
            'ckeditor',
            'countryDirective',
            'daterangepicker',
            'fuelux.wizard',
            'mgo-angular-wizard',
            'easypiechart',
            'ui.calendar',
            'ngAnimate',
            'angularMoment',
            'daterangepicker',
            'ui.bootstrap.datetimepicker',
            'ngWebworker',
            'ngTagsInput'
        ]);
})();